<div class="pl-input-box form-field tall" [ngClass]="{ invalid: isInvalid, bordered: isBordered, disabled: disabled }">
  <ng-content></ng-content>
</div>
